import { boot } from 'quasar/wrappers'

import { LocalStorage } from 'quasar'
import jwtDecode from 'jwt-decode'
import fetch from 'src/assets/api/fetch'

export function signIn (accessToken: string): void {
  saveAccessTokenToStorage(accessToken)
}

export function signOut (): void {
  saveAccessTokenToStorage('')
  window.document.location.href = process.env.VUE_ROUTER_BASE + 'auth'
}

export default boot(async ({ urlPath }) => {
  const accessToken = readAccessTokenFromStorage()
  if (accessToken) try {
    const accessTokenDecoded: JsonWebToken = jwtDecode(accessToken)
    if (isAccessTokenExpired(accessTokenDecoded)) {
      saveAccessTokenToStorage('')
    } else {
      setAccessTokenRefreshTimeout(accessTokenDecoded.exp)
      if (urlPath.startsWith(process.env.VUE_ROUTER_BASE + 'auth')) {
        return Promise.reject({ url: process.env.VUE_ROUTER_BASE + '' })
      }
      return
    }
  } catch (e) {
    saveAccessTokenToStorage('')
  }
  if (!urlPath.startsWith(process.env.VUE_ROUTER_BASE + 'auth') && !urlPath.startsWith(process.env.VUE_ROUTER_BASE + 'guest')) {
    return Promise.reject({ url: process.env.VUE_ROUTER_BASE + 'auth' })
  }
})

export function readAccessTokenFromStorage (): string {
  return LocalStorage.getItem('accessToken') || ''
}

function saveAccessTokenToStorage (accessToken: string): void {
  LocalStorage.set('accessToken', accessToken)
}

function setAccessTokenRefreshTimeout (expTime: number) {
  const timeToRefresh: number = calculateTimeToRefresh(expTime)
  window.setTimeout(() => {
    fetch('/api/account/token-refresh').then(async (response) => {
      const accessToken = await response.text()
      saveAccessTokenToStorage(accessToken)
      const accessTokenDecoded: JsonWebToken = jwtDecode(accessToken)
      setAccessTokenRefreshTimeout(accessTokenDecoded.exp)
    }).catch(() => {
      signOut()
    })
  }, timeToRefresh)
}

function calculateTimeToRefresh (expTime: number): number {
  const randomMinutes: number = Math.ceil(Math.random() * 5) * 60
  const fixedMinutes: number = 60 * 60
  const refreshTimeBeforeExp: number = fixedMinutes + randomMinutes
  const timeToExp: number = expTime - Math.ceil(Date.now() / 1000)
  return 1000 * Math.max(0, timeToExp - refreshTimeBeforeExp)
}

function isAccessTokenExpired (accessTokenDecoded: JsonWebToken): boolean {
  return (accessTokenDecoded.exp || 0) < Math.ceil(Date.now() / 1000)
}
